import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/common';

const FormDeleteButton = (props) => {
  const { text, style, icon, ...restProps } = props;
  return (
    <Button
      type='danger'
      style={{ borderRadius: '4px', ...(style || {}) }}
      icon={icon || <DeleteOutlined />}
      {...restProps}
    >
      {text === null ? null : (
        <span>{text || <FormattedMessage {...Messages.deleteBtn} />}</span>
      )}
    </Button>
  );
};

export default FormDeleteButton;
